export const defaultReportData = {
  overview: {
    reportDate: new Date().toISOString().slice(0, 10), // Default to today
    executiveSummary: "This month, we achieved significant growth in organic traffic and improved keyword rankings. Our social media engagement has also seen a steady increase.",
    traffic: 0,
    conversions: 0,
    revenue: 0,
    conversionRate: 0,
    techHealth: 100,
    activeKeywords: 0,
    backlinks: 0,
    trafficTrend: [
      { month: 'Jan', traffic: 0, conversions: 0 },
      { month: 'Feb', traffic: 0, conversions: 0 },
      { month: 'Mar', traffic: 0, conversions: 0 },
      { month: 'Apr', traffic: 0, conversions: 0 },
      { month: 'May', traffic: 0, conversions: 0 },
      { month: 'Jun', traffic: 0, conversions: 0 }
    ]
  },
  seo: {
    traffic: 0,
    conversions: 0,
    techHealth: 100,
    backlinks: 0,
    newBacklinks: 0,
    referringDomains: 0,
    postsThisMonth: 0,
    keywords: [
      { keyword: 'Example Keyword', position: 1, change: 0, searches: 1000, difficulty: 'Medium' }
    ],
    trafficHistory: [
      { month: 'Jan', organic: 0, clicks: 0 },
      { month: 'Feb', organic: 0, clicks: 0 },
      { month: 'Mar', organic: 0, clicks: 0 },
      { month: 'Apr', organic: 0, clicks: 0 },
      { month: 'May', organic: 0, clicks: 0 },
      { month: 'Jun', organic: 0, clicks: 0 }
    ]
  },
  gbp: {
    actions: 0,
    views: 0,
    rating: 5.0,
    newReviews: 0,
    mapPackAppearances: 0,
    avgPosition: 0,
    visibilityScore: 0,
    history: [
      { month: 'Jan', actions: 0, views: 0 },
      { month: 'Feb', actions: 0, views: 0 },
      { month: 'Mar', actions: 0, views: 0 },
      { month: 'Apr', actions: 0, views: 0 },
      { month: 'May', actions: 0, views: 0 },
      { month: 'Jun', actions: 0, views: 0 }
    ],
    reviews: [
      { name: 'Happy Client', rating: 5, text: 'Great service!', date: '1 week ago' }
    ]
  },
  social: {
    platforms: {
      linkedin: { impressions: 0, engagement: 0, clicks: 0, followers: 0, posts: 0 },
      facebook: { impressions: 0, engagement: 0, clicks: 0, followers: 0, posts: 0 },
      instagram: { impressions: 0, engagement: 0, clicks: 0, followers: 0, posts: 0 },
      twitter: { impressions: 0, engagement: 0, clicks: 0, followers: 0, posts: 0 },
      tiktok: { impressions: 0, engagement: 0, clicks: 0, followers: 0, posts: 0 }
    }
  },
  googleAds: {
    roas: 0,
    costPerConv: 0,
    convRate: 0,
    cpc: 0,
    qualityScore: 0,
    impressionShare: 0,
    spend: 0,
    conversions: 0,
    clicks: 0,
    campaigns: [
      { name: 'Campaign 1', spend: 0, conversions: 0, roas: 0 }
    ],
    history: [
      { month: 'Jan', roas: 0, cost: 0, conversions: 0 },
      { month: 'Jun', roas: 0, cost: 0, conversions: 0 }
    ]
  },
  metaAds: {
    roas: 0,
    costPerResult: 0,
    convRate: 0,
    ctr: 0,
    frequency: 0,
    cpm: 0,
    adSets: [
      { name: 'Ad Set 1', platform: 'Facebook', spend: 0, results: 0, roas: 0, audience: 'General' }
    ],
    history: [
      { month: 'Jan', roas: 0, cost: 0, ctr: 0 },
      { month: 'Jun', roas: 0, cost: 0, ctr: 0 }
    ]
  },
  youtube: {
    viewRate: 0,
    costPerView: 0,
    completion: 0,
    earnedSubs: 0,
    ctr: 0,
    views: 0,
    campaigns: [
      { name: 'Video Campaign 1', type: 'In-Stream', views: 0, completion: 0, earnedSubs: 0, costPerView: 0, objective: 'Awareness' }
    ],
    history: [
      { month: 'Jan', viewRate: 0, completion: 0, views: 0 },
      { month: 'Jun', viewRate: 0, completion: 0, views: 0 }
    ]
  },
  email: {
    openRate: 0,
    clickRate: 0,
    listGrowth: 0,
    unsubRate: 0,
    listSize: 0,
    emailsSent: 0,
    campaigns: [
      { name: 'Newsletter', type: 'Newsletter', sent: 0, openRate: 0, clickRate: 0, conversions: 0 }
    ],
    history: [
      { month: 'Jan', openRate: 0, clickRate: 0, listSize: 0 },
      { month: 'Jun', openRate: 0, clickRate: 0, listSize: 0 }
    ]
  },
  content: {
    blogPostsCount: 0,
    socialPostsCount: 0,
    upcomingBlogs: [
      { id: 1, title: 'Example Post', publishDate: '2024-01-01', status: 'draft', author: 'Team' }
    ],
    upcomingSocial: [
      { id: 1, content: 'Social post content', platform: 'Facebook', publishDate: '2024-01-01', type: 'Educational' }
    ],
    upcomingVideos: [
      { id: 1, title: 'Video Concept', platform: 'YouTube', publishDate: '2024-01-01', duration: '1:00', type: 'Educational' }
    ]
  }
};